export default fileName => fileName.replace(/--dpsk\w+--dpsk\./g, ".");
